export default {
    title: "Greetings",
    name: "Name",
    password: "Password",
    login: "Login",
    guest: "Guest"
}